<template>
    <div class="section" id="section-projet">
        <div class="section-content">
            <div v-if="!loaded" class="container_preload">
                <div class="roulette"></div>
            </div>
            <div v-else-if="loaded">
                <div class="section-content-banner">
                    <div>LE PROJET</div>
                    <div>outils</div>
                    <div class="closer fermer" @click="closeFooter()">╳</div>
                </div>
                <div class="section-content-loaded">
                    <div v-html="content" class="wysiwyg-content"></div>
                    <div class="partnerships">
                        <ul id="partners-list">
                            <li v-for="partner in partners">
                                <a :href="partner.url" target="_blank"><img :src="host + partner.file" class="partner-logo"></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { url_annexes } from '../../variables.js';
    import { url_files } from '../../variables.js';

    export default {
        data() {
            return {
                loaded:false,
                content:"",
                partners : [],
                host : url_files, // host : location.protocol + "//" + location.hostname,
            }
        },

        mounted: function() {
            this.axios.get(url_annexes+"projet").then((response) => {
                this.content = response.data.contenu;
                this.partners = response.data.partners;
                this.loaded = true;
            });
        },
        methods : {
            closeFooter(){
                console.log(this);
                document.body.setAttribute("data-footer",false);
                document.body.setAttribute("data-mode","");
            }
        }
    };
</script>

<style>
    :root{
        --img-max-width: 160px;
    }
    .wysiwyg-content{
        margin-bottom: calc(var(--interlignage-courant) * 2);
    }
    #partners-list, #partners-list li{
        list-style: none;
    }
    #partners-list{
        padding-bottom: 10vh;
    }
    #partners-list li{
        display: inline-block;
        margin-right: calc(var(--lrm)*3);
        padding-bottom: calc(var(--tbm)*1);
        margin-bottom: calc(var(--lrm)*3);
        /*box-shadow: 0 0 0 1px black;*/
    }
    #partners-list li:hover{
        /*border-bottom: 2px solid black;*/
        opacity: 0.7;
    }

    .partner-logo{
        min-width: var(--img-max-width);
        max-width: var(--img-max-width);
        min-height: var(--interlignage-courant);
        background-color: transparent;
    }
</style>